import * as React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  appName: string;
  appSubtitle?: string;
}

export const Logo = (props: LogoProps) => (
  <div className="layout-branding">
    <h2 className="logo">UC Davis Graduate Studies</h2>

    <h1 className="app-name">
      <Link to="/">{props.appName}</Link>
      {props.appSubtitle ? (<small>{props.appSubtitle}</small>) : ''}
    </h1>
  </div>
);



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/Logo.tsx